import { render, staticRenderFns } from "./DetailsHead.vue?vue&type=template&id=bd9ede70&scoped=true"
import script from "./DetailsHead.vue?vue&type=script&lang=js"
export * from "./DetailsHead.vue?vue&type=script&lang=js"
import style0 from "./DetailsHead.vue?vue&type=style&index=0&id=bd9ede70&prod&scoped=true&lang=css"
import style1 from "./DetailsHead.vue?vue&type=style&index=1&id=bd9ede70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9ede70",
  null
  
)

export default component.exports